/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/SplitButton",
    "MW/toolstrip/mixins/property/MnemonicMixin",
    "MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/SizeMixin",
    "MW/toolstrip/form/mixins/property/DropDownButtonSizeMixin",
    "MW/toolstrip/form/mixins/property/DropDownButtonTextMixin",
    "MW/toolstrip/mixins/property/OrientationMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/MenuIdMixin",
    "MW/toolstrip/mixins/property/MenuMixin",
    "MW/toolstrip/mixins/property/PreventRestoreFocusMixin",
    "mw-form/mixins/ResizeMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "MW/toolstrip/mixins/property/QuickAccessIconMixin",
    "MW/toolstrip/mixins/property/TooltipMixin",
    "MW/toolstrip/mixins/property/ShowTextMixin",
    "MW/toolstrip/form/mixins/property/SplitLikeButtonTooltipMixin",
    "MW/toolstrip/form/mixins/property/DropDownLikeButtonA11yMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, SplitButton, MnemonicMixin, MnemonicKeyNavDirectionMixin, IconMixin, IconOverrideMixin,
             TextMixin, SizeMixin, DropDownButtonSizeMixin, DropDownButtonTextMixin, OrientationMixin, TextOverrideMixin,
             TypeMixin, DescriptionOverrideMixin, MenuIdMixin, PreventRestoreFocusMixin,
             MenuMixin, ResizeMixin, ShortcutMixin, QuickAccessIconMixin, TooltipMixin, ShowTextMixin,
             SplitLikeButtonTooltipMixin, DropDownLikeButtonA11yMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([SplitButton, MnemonicMixin, MnemonicKeyNavDirectionMixin,
        IconMixin, IconOverrideMixin, TextMixin, SizeMixin, DropDownButtonSizeMixin,DropDownButtonTextMixin, OrientationMixin,
        TextOverrideMixin, TypeMixin, DescriptionOverrideMixin, ShortcutMixin, QuickAccessIconMixin, MenuIdMixin,
        MenuMixin, PreventRestoreFocusMixin, ResizeMixin, TooltipMixin, ShowTextMixin, SplitLikeButtonTooltipMixin,
        DropDownLikeButtonA11yMixin]), {
        visualFamily: "default",
        minWidth: 38,

        // TODO: Merge the shared code below (ToggleSplitButton.js) into a mixin once we have fully migrated to 2p
        /* g1448487: After the element has been placed in the DOM we need to
         * round up the width since the node is almost guaranteed to have
         * sub-pixel width, and in IE this sub-pixel width can lead to elements being
         * clipped oddly, which makes them shift by 1 pixel after gaining focus.
         */
        resize: function () {
            this.inherited(arguments);

            // TODO: Update to use a common utility with other feature detection methods
            var hasIE = navigator.appName === 'Microsoft Internet Explorer' || (navigator.appName === "Netscape" && navigator.appVersion.indexOf('Edge') > -1);

            if (hasIE) {
                this._updateTextNodeWidth();

                this.own(
                    this.watch("text", this._updateTextNodeWidth)
                );
            }
        },

        _updateTextNodeWidth: function () {
            if (this.textNode &&
                !this.textNode.classList.contains("mwEmptyNode") &&
                this.domNode.classList.contains("mwHorizontalOrientation")) {
                // In IE the elements are not added to the DOM until after this method is called, so
                // we use setTimeout to get behind the placement in the DOM
                setTimeout(function () {
                    // We need to check for the textNode again because on Edge, the timeout can cause
                    // the function to be called after the widget has been destroyed
                    if (this.textNode) {
                        // Clear the previous width that may have been set so that the width will auto size
                        this.textNode.style.width = "";
                        // Set the width of the Text Node to an integer value larger than the float value
                        this.textNode.style.width =
                            Math.ceil(parseFloat(window.getComputedStyle(this.textNode,
                                null).width)) +
                            "px";
                    }
                }.bind(this), 0);
            }
        }
    });

});
